import { Auth } from "../components/Form/Form";

const url = '/api/hierarchy';

export const HierarchieClubsApi = {
    all: () => fetch(`${url}`, Auth.options('GET')).then(res => res.json()),
}